
// 基础
import basic from './basic.js'

let allUrlList = Object.assign(
    {},basic,
);
export default allUrlList 


// WEBPACK FOOTER //
// ./src/api/url/url.js